import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from '../../../../base.graphql';

export const citizenVerifyPhoneNumberField = `
id
citizenUniqueId
citizenPhoneNumber
`;



export const CITIZEN_VERIFY_PHONE_NUMBER = gql`
mutation CitizenVerifyPhoneNumber($userPhoneNumber: String!) {
    citizenVerifyPhoneNumber(userPhoneNumber: $userPhoneNumber) {
    ${baseResponseGraphqlField}
    data {
      ${citizenVerifyPhoneNumberField}
    }
  }
}
`;

